/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Countdown_HintInputs */

const en_us2_body_assessment_countdown_hint = /** @type {(inputs: Body_Assessment_Countdown_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Step back onto your mark, about 2 m away. After the countdown a voice guides you, and the photo is taken by itself once the pose is right.`)
};

const pt_br2_body_assessment_countdown_hint = /** @type {(inputs: Body_Assessment_Countdown_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volte para a sua marca, a uns 2 m. Depois da contagem, a voz vai guiando e a foto sai sozinha quando a pose estiver certa.`)
};

const es_419_body_assessment_countdown_hint = /** @type {(inputs: Body_Assessment_Countdown_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuelve a tu marca, a unos 2 m. Después de la cuenta regresiva una voz te guía, y la foto se toma sola cuando la pose está bien.`)
};

const pt_pt2_body_assessment_countdown_hint = /** @type {(inputs: Body_Assessment_Countdown_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volta para a tua marca, a uns 2 m. Depois da contagem, uma voz vai-te guiando e a foto é tirada sozinha quando a pose estiver certa.`)
};

const fr_fr2_body_assessment_countdown_hint = /** @type {(inputs: Body_Assessment_Countdown_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retourne sur ta marque, à environ 2 m. Après le compte à rebours, une voix te guide et la photo se prend toute seule quand la pose est bonne.`)
};

const de_de2_body_assessment_countdown_hint = /** @type {(inputs: Body_Assessment_Countdown_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geh zurück auf deine Markierung, etwa 2 m entfernt. Nach dem Countdown führt dich eine Stimme, und das Foto wird von selbst gemacht, sobald die Pose stimmt.`)
};

const it_it2_body_assessment_countdown_hint = /** @type {(inputs: Body_Assessment_Countdown_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torna al tuo segno, a circa 2 m. Dopo il conto alla rovescia una voce ti guida, e la foto si scatta da sola quando la posa è giusta.`)
};

/**
* | output |
* | --- |
* | "Step back onto your mark, about 2 m away. After the countdown a voice guides you, and the photo is taken by itself once the pose is right." |
*
* @param {Body_Assessment_Countdown_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_countdown_hint = /** @type {((inputs?: Body_Assessment_Countdown_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Countdown_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_countdown_hint(inputs)
	if (locale === "es-419") return es_419_body_assessment_countdown_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_countdown_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_countdown_hint(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_countdown_hint(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_countdown_hint(inputs)
	return en_us2_body_assessment_countdown_hint(inputs)
});
export { body_assessment_countdown_hint as "body-assessment.countdown_hint" }